import React from 'react';
import { Button } from '../ui';

/**
 * Toggle to filter dashboards to "Problems Only" (yellow/red metrics).
 * Props: enabled (boolean), onChange (function), count (number - problem count for badge)
 */
function ProblemsOnlyToggle({ enabled, onChange, count = 0 }) {
  return (
    <div className="flex items-center gap-2">
      <Button
        variant="ghost"
        size="sm"
        type="button"
        onClick={() => onChange(false)}
        className={`px-4 py-2 rounded-lg font-medium text-sm transition-colors ${
          !enabled ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
        }`}
      >
        Show All
      </Button>
      <Button
        variant="ghost"
        size="sm"
        type="button"
        onClick={() => onChange(true)}
        className={`px-4 py-2 rounded-lg font-medium text-sm transition-colors flex items-center gap-2 ${
          enabled ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
        }`}
      >
        Problems Only
        {count > 0 && (
          <span className={`px-2 py-0.5 rounded text-xs font-bold ${enabled ? 'bg-white/20' : 'bg-red-100 text-red-800'}`}>
            {count}
          </span>
        )}
      </Button>
    </div>
  );
}

export default ProblemsOnlyToggle;
